import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useCallback, useState } from 'react';
import parse from 'html-react-parser';
import {
  DialogContainer,
  StyledButton,
  StyledDialog,
  TitleDialog
} from './styles';

interface DialogProps {
  title: any;
  description: any;
  isTerm?: boolean | false;
}

export default function ResponsiveDialog({ title, description, isTerm }: DialogProps) {
  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <DialogContainer $subject="portuguese" $isterm={isTerm}>
      <Button variant="text" onClick={handleClickOpen}>
        <span>{title}</span>
      </Button>
      <StyledDialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <TitleDialog $subject="portuguese">{title.charAt(0).toUpperCase() + title.slice(1)}</TitleDialog>
        <DialogContent sx={{ padding: 0 }}>
          <DialogContentText>
            {parse(description)}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: 0 }}>
          <StyledButton $subject="portuguese" onClick={handleClose}>
            Voltar
          </StyledButton>
        </DialogActions>
      </StyledDialog>
    </DialogContainer>
  );
}
